import React from 'react';
import Plyr from 'plyr-react';
import 'plyr-react/plyr.css'; // Importa os estilos do Plyr


const getRandomVideoId = () => {
    const videoIds = ['jjciiETyR0M', 'ELu4L0m09TA', '-yExdi3vHOc', '1x5LjXjJoEI']; // Adicione mais IDs de vídeos conforme necessário
    const randomIndex = Math.floor(Math.random() * videoIds.length);
    return videoIds[randomIndex];
};


const Watch = () => {
    return (
        <section id="assista" className="watch">
            <div className="container">
                <div className="row py-5">
                    <div className="col-12 title-watch text-center">Assiste quem já foi atendido pela Saúde Móvel Brasil</div>
                </div>
                <div className="row pb-5">
                    <div className="col-12">
                        <Plyr
                            source={{
                                type: 'video', // Tipo do player
                                sources: [
                                    {
                                        src: getRandomVideoId(), // ID do vídeo do YouTube
                                        provider: 'youtube', // Plataforma
                                    },
                                ],
                            }}
                            options={{
                                controls: ['play', 'progress', 'volume', 'fullscreen'], // Controles personalizados
                                autoplay: false, // Não reproduzir automaticamente
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Watch;